import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../store/actions/actions';

import { Query } from 'react-apollo';
import { GET_AUTH_INFO } from '../../graphql/queries/configuracion';
import HeaderRun from './Header.run';
import UserProfileWidget from '../Configuration/UserProfileWidget';

import history from '../../history';

//components
import { menuItems } from './_configMenu';
import HeaderMenu from '../Layout/HeaderMenu';

class Header extends Component {
  state = {
    actionMenu: '1'
  };

  componentDidMount() {
    HeaderRun();
  }

  toggleCollapsed = e => {
    e.preventDefault();
    this.props.actions.toggleSetting('isCollapsed');
    this.resize();
  };

  toggleUserProfile = e => {
    e.preventDefault();
    this.props.actions.toggleDialog('userProfile');
  };

  resize() {
    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }

  menuClicked = action => {
    this.setState({ actionMenu: action });
  };

  render() {
    return (
      <Query query={GET_AUTH_INFO}>
        {({ loading, data }) => {
          /*if (loading) {
            return <>
            <div className='head'>
              <div className='logo'>
                <img
                  src='img/logo_headBlanco.svg'
                  alt='SHERPA'
                  style={{ cursor: 'pointer' }}
                  onClick={() => history.push('/inicio')}
                />
              </div>


              <div style={{ background: 'white', marginTop: '5vw' }}>
                <HeaderMenu items={menuItems} />
              </div>
            </div>
          </>;
          }*/

          if (
            loading === false &&
            data &&
            data.configuracion &&
            !data.configuracion.authInfo
          ) {
            history.push('/login');
            return null;
          }

          return (
            <>
              <div className='head'>
                <div className='logo'>
                  <img
                    src='img/logo_headBlanco.svg'
                    alt='SHERPA'
                    style={{ cursor: 'pointer' }}
                    onClick={() => history.push('/inicio')}
                  />
                </div>

                {data && data.configuracion && data.configuracion.authInfo && (
                  <UserProfileWidget authInfo={data.configuracion.authInfo} />
                )}

                {data && data.configuracion && data.configuracion.authInfo && (
                  <div style={{ background: 'white', marginTop: '5vw' }}>
                    <HeaderMenu items={menuItems} />
                  </div>
                )}
              </div>
            </>
          );
        }}
      </Query>
    );
  }
}

Header.propTypes = {
  actions: PropTypes.object,
  settings: PropTypes.object,
  onClickBars: PropTypes.func
};

const mapStateToProps = state => ({ settings: state.settings });
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
